angular
  .module("AccountingBoxApp")
  .filter("vatRateDateFilter", function($filter) {
    console.warn('vatRateDateFilter is deprecated!');
    return function(vatRates, journalDate) {
      var parsedJournalDate = moment(journalDate, "DD-MM-YYYY");
      console.log("parsedJournalDate is", parsedJournalDate);

      return vatRates.filter(function(vatRate) {
        console.log("vatRate begin date is", vatRate.begindate);
        console.log("vatRate end date is", vatRate.endDate);

        if (
          vatRate.beginDate &&
          parsedJournalDate.isBefore(vatRate.beginDate)
        ) {
          console.log(
            "parsedJournalDate.isBefore(vatRate.beginDate)",
            parsedJournalDate.isBefore(vatRate.beginDate)
          );
          return false;
        }
        if (vatRate.endDate && parsedJournalDate.isAfter(vatRate.endDate)) {
          console.log(
            "parsedJournalDate.isAfter(vatRate.endDate))",
            parsedJournalDate.isAfter(vatRate.endDate)
          );
          return false;
        }
        console.log("return true");
        return true;
      });
    };
  });
